export const UPDATE_SOURCES_LOADER = 'UPDATE_SOURCES_LOADER';
export const TRIGGER_SOURCES_LOADER = 'TRIGGER_SOURCES_LOADER';
export const SHOW_SOURCES_LOADER = 'SHOW_SOURCES_LOADER';
export const HIDE_SOURCES_LOADER = 'HIDE_SOURCES_LOADER';
export const START_HIDE_SOURCES_LOADER_TIMER = 'START_HIDE_SOURCES_LOADER_TIMER';



// WEBPACK FOOTER //
// ./app/Sources/loader/actionTypes.js